import { UserActions } from '@chegg/commerce-utils';

// PAUSE - unsupported.  this denotes a user with an active subscription
/**
 * Determines if the supplied user action is an order management action
 * @param action The user action being evaluated
 */
export var isOrderManagementAction = function isOrderManagementAction(action) {
  return action === UserActions.RESUME || action === UserActions.REVOKE_PENDING_CANCEL || action === UserActions.REVOKE_PENDING_PAUSE;
};

/**
 * Determines if the supplied user action is a cart checkout action
 * @param action The user action being evaluated
 */
export var isCartCheckoutAction = function isCartCheckoutAction(action) {
  return action === UserActions.RESUBSCRIBE || action === UserActions.JOIN || action === UserActions.UPGRADE;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/utils/FetchActionUtil.js
// module id = 1445
// module chunks = 11